import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PaginatedItems from "../../../common/Pagination";
import { getMERLibraryAction } from "../../../redux/actions/AppoinmentAction";
import { clearCurrentPage } from "../../NetworkPortal/ProviderProfileDetails/helper";

export const MERLibraryPopup = ({ setOpenMerpopup }) => {
  const dispatch = useDispatch();
  const getMerLibrary = useSelector(
    (state) => state?.AppoinmentReducer?.getMerLibrary
  );
  const globalReducer = useSelector((state) => state?.globalReducer);

  useEffect(() => {
    dispatch(getMERLibraryAction(globalReducer?.getCurrentPage));
  }, [globalReducer?.getCurrentPage]);

  return (
    <div className="modal-content _customModalContent">
      <div className="d-flex justify-content-between border-bottom modalHeader">
        <h4 className="font-bold text-black">MER Library</h4>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            setOpenMerpopup(false);
            clearCurrentPage(dispatch);
          }}
        ></button>
      </div>
      <div className="modal-body" style={{ height: "100%" }}>
        <div className="downloadable-files">
          <div className="client_list">
            <div className="client_files">
              {getMerLibrary?.map((ele, index) => {
                return (
                  <div className="modalContentWidth" key={index}>
                    <a href={ele?.link}>
                      <img src="./images/pdf-file.svg" alt="" width="70" />
                      <p>{ele?.clientname}</p>
                    </a>
                  </div>
                );
              })}
            </div>
            <div className="mt-4">
              {globalReducer?.getTotalCount !== 0 && (
                <PaginatedItems
                  totalCount={globalReducer?.getTotalCount}
                  perPageData="8"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
